const BASE_URL = '/api/google-accounts';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export interface GoogleAccount {
  id: number;
  account_alias: string;
  google_email: string;
  scopes: string;
  needs_reauth: boolean;
  created_at: string;
  updated_at: string;
}

export async function listGoogleAccounts(): Promise<GoogleAccount[]> {
  return fetchJson<GoogleAccount[]>(BASE_URL);
}

export async function disconnectGoogleAccount(id: number): Promise<void> {
  await fetchJson(`${BASE_URL}/${id}`, { method: 'DELETE' });
}

export async function updateGoogleAccountAlias(id: number, alias: string): Promise<void> {
  await fetchJson(`${BASE_URL}/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ alias }),
  });
}
